import { useAuth } from 'common/context'
import { AuthUser } from 'common/types'

export const useAuthUser = (): AuthUser | null => {
  const { user } = useAuth()

  return user
}
